<div
  class="nes-flex nes-justify-between nes-items-center nes-p-2"
  [ngClass]="{ 'nes-bg-tint-secondary-accent': isEven }"
>
  <div class="nes-flex nes-items-center nes-gap-10">
    <div
      class="nes-flex nes-justify-center nes-items-center nes-rounded nes-h-12 nes-w-12 nes-bg-form-bg"
    >
      <nes-icon
        [name]="getIconName(service.url)"
        color="blue-500"
        role="presentation"
        aria-hidden="true"
      ></nes-icon>
    </div>
    <nes-text>
      {{
        "COMPOSE.CHOOSE_EXTRAS.SERVICES." + service.identifier + ".TITLE"
          | translate
      }}
    </nes-text>
  </div>
  <div class="nes-flex nes-items-center nes-gap-10">
    <nes-tooltip
      [nesId]="
        'COMPOSE.CHOOSE_EXTRAS.SERVICES.' + service.identifier + '_tooltip'
      "
      [attr.aria-label]="
        'COMPOSE.CHOOSE_EXTRAS.SERVICES.' + service.identifier + '.TITLE'
          | translate
      "
    >
      <div [innerHTML]="tooltip | translate"></div>
    </nes-tooltip>
    <nes-toggle
      [nesId]="service.identifier + '_toggle'"
      [checked]="service.selected"
      (nesOnChange)="toggleSelection($event)"
      [attr.aria-label]="
        'COMPOSE.CHOOSE_EXTRAS.SERVICES.' + service.identifier + '.TITLE'
          | translate
      "
    ></nes-toggle>
  </div>
</div>
